import { render, staticRenderFns } from "./ParametreTarifs.vue?vue&type=template&id=6ad0fdca&scoped=true"
import script from "./ParametreTarifs.vue?vue&type=script&lang=js"
export * from "./ParametreTarifs.vue?vue&type=script&lang=js"
import style0 from "./ParametreTarifs.vue?vue&type=style&index=0&id=6ad0fdca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad0fdca",
  null
  
)

export default component.exports